import ExposedAssetList from "./"
import { useParams } from "react-router-dom"
import { compose, withProps } from "recompose"
import { graphql } from "@apollo/client/react/hoc"
import cloudinary from "cloudinary-core"
import moment from "moment"
import { EXPOSED_ASSET_LIST } from "../../apollo/queries"

const cloudinaryClient = new cloudinary.Cloudinary({
  cloud_name: "swipesense-inc",
})

const ExposedAssetListEnhanced = compose(
  withProps(() => {
    const { facilityId, caseId } = useParams()
    return {
      facilityId,
      caseId,
    }
  }),
  graphql(EXPOSED_ASSET_LIST, {
    options: ({ facilityId, caseId }) => ({
      variables: { facilityId, caseId },
    }),
    props: ({ data: { error, loading, facility } }) => {
      if (error) throw error

      if (loading) return { loading }

      if (facility.contactTracingCases.length === 0) throw Error("404")

      const kase = facility.contactTracingCases[0]

      if (kase.type !== "patientPositive") {
        throw Error("Entity type must be location.")
      }
      const entities = kase.subjects.map((subject) => ({
        id: subject.entity.id,
        startAt: subject.startAt,
        endAt: subject.endAt,
      }))

      return {
        startAt: moment
          .min(
            kase.subjects.map((subject) => moment.parseZone(subject.startAt))
          )
          .format(),
        endAt: moment
          .max(kase.subjects.map((subject) => moment.parseZone(subject.endAt)))
          .format(),
        entities: entities,
        rows: kase.exposedAssets.map((exposedAsset) => {
          const timeStationary = moment
            .parseZone(exposedAsset.exposed.lastSeenAt)
            .diff(moment.parseZone(exposedAsset.exposed.lastMovedAt))
          const timeSinceDetected = moment().diff(
            moment.parseZone(exposedAsset.exposed.lastSeenAt)
          )
          const isMissing = timeSinceDetected > 3600000 // 1 hour in ms
          const isStationary = timeStationary > 300000 // 5 minutes in ms

          return {
            asset: {
              ...exposedAsset.exposed,
              location: {
                ...exposedAsset.exposed.location,
                timeStationary,
                isStationary,
                timeSinceDetected,
                isMissing,
                idle:
                  exposedAsset.exposed.lastSeenAt === null ||
                  exposedAsset.exposed.location === null ||
                  isMissing,
              },
              desktopPhotoUrl:
                exposedAsset.exposed.imageId &&
                cloudinaryClient.url(exposedAsset.exposed.imageId, {
                  width: 119,
                  height: 119,
                  crop: "fill",
                }),
            },
            firstContact: moment.parseZone(exposedAsset.firstContact),
            lastContact: moment.parseZone(exposedAsset.lastContact),
            exposureDuration: moment.duration(
              exposedAsset.exposureDuration,
              "seconds"
            ),
          }
        }),
      }
    },
  })
)(ExposedAssetList)

export default ExposedAssetListEnhanced
